import classNames from 'classnames';
import dayjs from 'dayjs';
import { Placement } from 'popper.js';
import React, { useRef, useState } from 'react';
import { HasClassName } from '../component-utils';
import Calendar from './Calendar';
import Flyout from './Flyout';
import Input from './Input';
import { PortalPopper } from './PortalPopper';
import { selectDateFormating } from '../store/reducers/config';
import { useSelector } from '../hook-utils';

interface Props extends HasClassName {
  value: number | null
  onChange(value: number): void
  placement?: Placement
  placeholder?: string
  disabled?: boolean
}

export default function DatePicker({ className, value, onChange, placeholder, placement = 'bottom-start', disabled }: Props) {
  const [ isOpen, setOpen ] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const format = useSelector(selectDateFormating)
  if (!format) return null

  function onDateClick(value: number) {
    setOpen(false)
    onChange(value)
  }

  return <div className={classNames('DatePicker', className)}>
    <Input readOnly innerRef={inputRef} onFocus={() => setOpen(true)} disabled={disabled} value={value === null ? '' : dayjs(value).format(format.shortDateFormat)} placeholder={placeholder} autocomplete={false}/>
    {isOpen && <PortalPopper referenceElement={inputRef.current || undefined} placement={placement}>
      {({ ref, style }) => <Flyout innerRef={ref} style={style}>
        <Calendar value={value === null ? Date.now() : value} onChange={onDateClick} onHide={() => setOpen(false)} />
      </Flyout>}
    </PortalPopper>}
  </div>
}
